module.exports = __webpack_public_path__ + "static/media/PromoImage_Loyalty.506c8d67.png";